<div class="prom-scroll-trigger" bind:this={scrollTrigger}></div>

<script>
    import { onMount, onDestroy, createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    let scrollTrigger;
    let scrollContainer;
    let visible = false;

    onMount(() => {
        scrollContainer = findScrollContainer(scrollTrigger);
        scrollContainer.addEventListener('scroll', handleContainerScroll)
    });

    onDestroy(() => scrollContainer.removeEventListener('scroll', handleContainerScroll));

    function handleContainerScroll() {
        const containerRect = scrollContainer.getBoundingClientRect()
        const triggerRect = scrollTrigger.getBoundingClientRect();

        const scrollViewTop = containerRect.y;
        const scrollViewBottom = containerRect.y + scrollContainer.clientHeight;

        const nowVisible = triggerRect.y <= scrollViewBottom && triggerRect.y >= scrollViewTop;

        if (!visible && nowVisible) {
            dispatch('visible');
        } else if (visible && !nowVisible) {
            dispatch('hidden');
        }

        visible = nowVisible;
    }

    function findScrollContainer(element) {
        let parent = element.parentElement;

        while (parent) {
            const { overflow } = window.getComputedStyle(parent);

            if (overflow.split(' ').every(o => o === 'auto' || o === 'scroll')) {
                return parent;
            }

            parent = parent.parentElement;
        }

        return document.documentElement;
    }
</script>